import React from 'react';
import { Section } from '../ui/Section';
import { OfferSelector } from './OfferSelector';
import { UrgencyBanner } from './UrgencyBanner';
export function Pricing() {
  return <Section id="pricing" className="bg-white" data-id="element-204">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-205">
        <div className="text-center mb-6 md:mb-10" data-id="element-206">
          
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-3 md:mb-4" data-id="element-207">
            Elegí tu sistema de gestión
          </h2>
          <p className="text-lg md:text-xl text-slate-600" data-id="element-208">
            Ambas opciones incluyen los 3 bonos estratégicos completos
          </p>
        </div>

        <UrgencyBanner data-id="element-209" />
        <OfferSelector theme="light" data-id="element-210" />
      </div>
    </Section>;
}